var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('main-toolbar'),_c('main-drawer'),_c('router-view'),_c('change-password-dialog'),_c('trocar-empresa-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }